import {useRef, Fragment, useState, useEffect, useMemo, Suspense} from 'react';
// import {useUpdate} from '@react-three/fiber';
import {useThree} from '@react-three/fiber';
import {TransformControls} from '@react-three/drei'
// import {TransformControls} from "three/examples/jsm/controls/TransformControls"; //this one is harder to put in scene (requires weird attach thing, see commented out below). Also gives issues when removing from scene.

import {extend} from '@react-three/fiber';

import {Line as Line2} from '@react-three/drei'

import {DeformingElement} from './deformingelement';
// import {DeformingElementTraj} from './deformingelementtraj';
import {CustomElement} from './customelement';
import {isZero, isNonzero} from './computation';
import {calculateRotQuat} from './visualmath';

import {count,zeros,norm} from 'mathjs';
import {Vector3, Color} from 'three';

extend({TransformControls})
// import {Line2, LineMaterial, LineGeometry} from 'three/examples/jsm/lines/';
// import { Line2 } from 'three/examples/jsm/lines/Line2.js';
// import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
// import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
// extend({Line2, LineMaterial, LineGeometry})

export const Elements = (props) => {

    const out = props.elements.map(
      (e,i) => {
        let points1 = new Vector3();
        let points2 = new Vector3();
        let points = [];
        
        // find index of nodes given nodeid
        const ii_p = props.nodes.findIndex( no => no.id === e.connect[0]);
        const ii_q = props.nodes.findIndex( no => no.id === e.connect[1]);

        points1.fromArray(props.nodes[ii_p].coord);
        points2.fromArray(props.nodes[ii_q].coord);
        points.push(points1);
        points.push(points2);

        var activeState = null;
        if (props.activeElement && props.activeElementId === e.id){
          activeState = true;
        }
        else {
          activeState = false;
        }

        // var w = null;
        // var t = null;
        // var color = null;
        let style = [];

        if (e.type === 'leaf'){
          style.w = 100;
          style.t = 10;
          style.color = "steelblue";
        }
        else if(e.type === 'rigid') {
          style.w = props.rigidSize;
          style.t = props.rigidSize;
          style.color = "slategray";
        }
        else if(e.type === 'wire') {
          style.w = 10;
          style.t = 10;
          style.color = "green";
        }
        else if(e.type === 'notch') {
          style.w = 100;
          style.t = 10;
          style.color = "orange";
        }

        var elementReturn = null;
        if (props.mode === 'analyze' && props.analysisType === 'underconstraints'){
          if (props.hasAnalyzed && props.analysisRes.status === 'success' && props.analysisRes.nunder > 0){

            let dcoord = [];
            dcoord.drp = props.nodes[ii_p].dpos;
            dcoord.dqp = props.nodes[ii_p].drot;
            dcoord.drq = props.nodes[ii_q].dpos;
            dcoord.dqq = props.nodes[ii_q].drot;
            
            if (e.type === 'custom'){

              elementReturn = (
                <Suspense fallback={<boxHelper />} key={e.id}>
                {/*<CustomElement key={e.id} file={e.file} scale={e.scale} rot={e.rot} visSettings={props.visSettings} dcoord={dcoord} color={e.color} />*/}
                </Suspense>
                );

            } else {

              elementReturn = 
                <DeformingElement
                  key={e.id}
                  rp0={points1}
                  rq0={points2}
                  coord={points} //shouldnt be here when also rp0 and rq0 -- just easier for now
                  locY={e.locY}
                  type={e.type}
                  dcoord={dcoord}
                  style={style}
                  visSettings={props.visSettings}
                />
            }
          }
          else {
            elementReturn = null;
          }
        }
        else {

          if (e.type === 'custom'){

              elementReturn = (
                <Suspense fallback={<boxHelper />} key={e.id}>
                <CustomElement key={e.id} file={e.file} scale={e.scale} rot={e.rot} visSettings={props.visSettings} color={e.color} />
                </Suspense>
                );

          } else {

              elementReturn = (
                    <Element 
                        coord={points} 
                        key={e.id} 
                        elementid={e.id}
                        locY={e.locY}
                        type={e.type}
                        selectElement={props.selectElement} 
                        active={activeState}
                        mode={props.mode}
                        enableOrbitControls={props.enableOrbitControls}
                        updateLocY={props.updateLocY}
                        hasAnalyzed={props.hasAnalyzed}
                        stressVec_p={e.stressVec_p}
                        stressVec_q={e.stressVec_q}
                        stressVec_Mc={e.stressVec_Mc}
                        stressVec_Fc={e.stressVec_Fc}
                        sig={e.sig}
                        analysisRes={props.analysisRes}
                        style={style}
                        // modelid={props.modelid}
                    />
                  );
          }
        }
        
        return elementReturn;
      }
    );



    return out;
};

const Element = (props) => {
  
  // const ref = useRef(geo => geo.setFromPoints(props.coord), [props.coord])

  // const {camera, gl, scene} = useThree();

  const {invalidate} = useThree();
  
  const [hovered, setHover] = useState(false);
  
  const hoverOver = (e) => {
    if(props.mode === 'elements'){
      e.stopPropagation();
      setHover(true);
    }
  }

  const hoverOut = (e) => {
    setHover(false);
  }

  const click = (e) => {
    if(props.mode === 'elements'){
      e.stopPropagation();
      props.selectElement(props.elementid);
    }
  }

  // const boxRef = useRef();
  // const meshRef = useRef();

  const [elMesh, elMeshRef] = useState();

  let centerpos = new Vector3();
  centerpos.addVectors(props.coord[0],props.coord[1]).divideScalar(2);

  let locX = new Vector3();
  locX.subVectors(props.coord[1],props.coord[0]);
  const locY = new Vector3().fromArray(props.locY);
  const length = locX.length();
  
  // console.log(locX.dot(locY));

  const quat = useMemo(()=>calculateRotQuat(props.coord,locY), [props.coord,locY]);

  const transformControlsRef = useRef();
  const enableOrbitControls = (val) => {
      props.enableOrbitControls(val)
    }

  const yvec = new Vector3(0,1,0)

  useEffect( ()=>{

        if (transformControlsRef.current) {
          const controls = transformControlsRef.current;
          const callback = (e) => {
            // console.log(!e.value)
            // console.log('draggingChanged')
            if(e.value){
              //dragging just started
              enableOrbitControls(false);
            }
            else {
              //dragging just ended
              let newY = elMesh.localToWorld(yvec).sub(centerpos);
              props.updateLocY(newY,props.elementid);

              enableOrbitControls(true);  
            }
          }

          controls.addEventListener('dragging-changed', callback)
          controls.addEventListener('change', invalidate)

          // controls.setSpace('local')
          // controls.showZ = false;
          // controls.showY = false;
          
          return () => {
            controls.removeEventListener('dragging-changed', callback)
            controls.removeEventListener('change', invalidate)
          }
        }
      }
    )

  const L = length;
  const w = props.style.w;
  const t = props.style.t;
  
  const L_steps = 8;
  const w_steps = 4;
  const t_steps = 2;

  const L_grid = linspace(-L/2,L/2,L_steps);
  const w_grid = linspace(-w/2,w/2,w_steps);
  const t_grid = linspace(-t/2,t/2,t_steps);

  let mesh = {x: [], y: [], z: []};
  let triangles = [];
  let normals = [];

  //front surface
  triangles = makeTriangles(t_steps,w_steps,false,triangles,0);
  mesh = makeMesh([-L/2],w_grid,t_grid,mesh);
  normals = makeNormals([-1,0,0],w_steps*t_steps,normals)

  //back surface
  triangles = makeTriangles(t_steps,w_steps,true,triangles,count(mesh.x));
  mesh = makeMesh([L/2],w_grid,t_grid,mesh);
  normals = makeNormals([1,0,0],w_steps*t_steps,normals)

  //top surface
  triangles = makeTriangles(w_steps,L_steps,true,triangles,count(mesh.x));
  mesh = makeMesh(L_grid,w_grid,[t/2],mesh);
  normals = makeNormals([0,0,1],L_steps*w_steps,normals)

  //bottom surface
  triangles = makeTriangles(w_steps,L_steps,false,triangles,count(mesh.x));
  mesh = makeMesh(L_grid,w_grid,[-t/2],mesh);
  normals = makeNormals([0,0,-1],L_steps*w_steps,normals)

  //left surface
  triangles = makeTriangles(t_steps,L_steps,true,triangles,count(mesh.x));
  mesh = makeMesh(L_grid,[-w/2],t_grid,mesh);
  normals = makeNormals([0,-1,0],t_steps*L_steps,normals)

  //right surface
  triangles = makeTriangles(t_steps,L_steps,false,triangles,count(mesh.x));
  mesh = makeMesh(L_grid,[w/2],t_grid,mesh);
  normals = makeNormals([0,1,0],t_steps*L_steps,normals)

  var triangles_typed = new Uint16Array(triangles);
  var normals_typed = new Float32Array(normals);

  var positions = new Float32Array(count(mesh.x)*3);
  for (let i=0;i<count(mesh.x);i++){
    positions[3*i] = mesh.x[i];
    positions[3*i+1] = mesh.y[i];
    positions[3*i+2] = mesh.z[i];
  }

  let color = props.style.color;
  let stressArrows = null;
  // compute stress if needed
  if (props.hasAnalyzed && props.analysisRes !== null && props.analysisRes.status === 'success' && props.analysisRes.nover > 0){

    const nulvec = new Vector3(0,0,0);
    const scaling = 150;
    // console.log('debug')
    // console.log(props)
    const arrowLength_Mc = scaling*props.stressVec_Mc.length();
    const arrowLength_Fc = scaling*props.stressVec_Fc.length();
    const dir_Mc = props.stressVec_Mc.clone().normalize();
    const dir_Fc = props.stressVec_Fc.clone().normalize();

    const newMc = props.stressVec_Mc.clone().multiplyScalar(scaling*0.9).toArray();
    const newFc = props.stressVec_Fc.clone().multiplyScalar(scaling*0.9).toArray();

    const headLength = 15;
    const headWidth = 18;

    stressArrows = (
      <Fragment>
      {/*<arrowHelper args={[props.stressVec_p,props.coord[0],scaling*props.stressVec_p.length(),0xff0000]} />
      <arrowHelper args={[props.stressVec_q,props.coord[1],scaling*props.stressVec_q.length(),0x0000ff]} />*/}
      <group quaternion={quat} position={centerpos}>
      {
        isNonzero(arrowLength_Mc) &&
        <Fragment>
        <arrowHelper args={[
            dir_Mc,
            nulvec,
            arrowLength_Mc,
            new Color('blue'),
            headLength,
            headWidth
            ]} 
        />
        <arrowHelper args={[
            dir_Mc,
            nulvec,
            arrowLength_Mc-headLength,
            new Color('blue'),
            headLength,
            headWidth
            ]} 
        />
        <Line2
          points={[[0,0,0],newMc]}
          color={"blue"}
          linewidth={1.3}
        />
        </Fragment>
      }
      {
        isNonzero(arrowLength_Fc) &&
        <Fragment>
        <arrowHelper args={[
            dir_Fc,
            nulvec,
            arrowLength_Fc,
            new Color('black'),
            headLength,
            headWidth
            ]} 
        />
        <Line2
          points={[[0,0,0],newFc]}
          color={"black"}
          linewidth={1.3}
        />
        </Fragment>
      }
      </group>
      </Fragment>
      );

    let sig = props.sig;

    //overwrite default color if this element carries load for this particular overconstraint:
    if (norm(props.sig)>0.001) {
        color = 'red';
    }
    else{
        color = 'lightgray';
    }

    //some special cases for the leaf:
    if (props.type === 'leaf'){
      if ( isNonzero(sig[0]) && isZero(norm([sig[4],sig[5]])) ) {
        //pure axial constraint
        color = 'yellow';
      }
      else if( isNonzero(sig[4]) && isZero(norm([sig[0],sig[5]])) ){
        //pure transverse constraint
        color = 'lightgreen';
      }
      else if( isNonzero(sig[5]) && isZero(norm([sig[0],sig[4]])) ){
        //pure moment constraint
        color = 'blue';
      }
      else if( isNonzero(sig[4]) && isNonzero(sig[5]) && isZero(sig[0])){
        //moment and tranverse constraint
        color = 'darkgreen';
      }
      else {
        // color = 'red';
      }
    }

    if (props.type === 'wire'){
      if ( isNonzero(sig[0]) && isZero(norm([sig[4],sig[5]])) ) {
        //pure axial constraint
        color = 'yellow';
      }
    }

    // var colors = new Float32Array(mesh_typed.length);
    // for (let i=0;i<mesh_typed.length/3;i++){
    //   colors[i*3]=0;
    //   colors[i*3+1]=1;
    //   colors[i*3+2]=0;
    // }
  }

  // old element box
  // const elementMesh = (
  //     <mesh ref={meshRef}>
  //       <boxGeometry args={[length,width,thickness]} ref={boxRef}/>
  //       <meshLambertMaterial color={props.flex ? "steelblue" : "slategray"} transparent="true" opacity="0.5" />
  //     </mesh>
  //   );

  // this to make sure that the geometry is updated whenever element type is changed
  const elGeom = useRef();
  useEffect(()=>{
    elGeom.current.attributes.position.needsUpdate = true;
  })

  // new element box with custom colors for visualizing stress
  const elementMesh = (
    <mesh ref={elMeshRef}>
      <bufferGeometry attach="geometry" ref={elGeom}>
        <bufferAttribute attach="index" array={triangles_typed} count={triangles_typed.length} itemSize={1} />
        <bufferAttribute attachObject={["attributes", "position"]} count={positions.length / 3} array={positions} itemSize={3} />
        {/*<bufferAttribute attachObject={["attributes", "color"]} count={colors / 3} array={colors} itemSize={3} />*/}
        <bufferAttribute attachObject={["attributes", "normal"]} count={normals_typed.length / 3} array={normals_typed} itemSize={3} />
        {/*<bufferAttribute attachObject={["attributes", "uv"]} count={uvs.length / 2} array={uvs} itemSize={2} />*/}
      </bufferGeometry>
      <meshLambertMaterial color={color} transparent="true" opacity="0.5" depthTest={false}/>
      {/*<meshBasicMaterial vertexColors={THREE.VertexColors} />*/}
      {
        props.type ==='notch' &&
        <Fragment>
        {props.mode === 'elements' && <arrowHelper args={[new Vector3(0,1,0),new Vector3(0,0,0),100,new Color('orange')]} />}
        <mesh>
          <cylinderGeometry args={[20,20,100,20]} attach="geometry" />
          <meshLambertMaterial color={new Color('brown')} transparent="true" opacity="0.5" attach="material" />
        </mesh>
        </Fragment>
      }
    </mesh>
  );

  let elementBox;
  if(props.mode === 'elements' && props.active){
    elementBox = (
      <TransformControls ref={transformControlsRef} quaternion={quat} position={centerpos} mode="rotate" space="local" showY={false} showZ={false}>
      {elementMesh}  
      </TransformControls>
    )
    // elementBox = (
    //   <Fragment>
    //   <group quaternion={quat} position={centerpos}>
    //   {elementMesh}
    //   </group>
    //   {elMesh && <transformControls ref={transformControlsRef} mode="rotate" args={[camera, gl.domElement]} onUpdate={(self)=>self.attach(elMesh)} />}
    //   </Fragment>
    // )
  }
  else {
    elementBox = (
      <group quaternion={quat} position={centerpos}>
      {elementMesh}
      </group>
    )
  }

  // one mesh (boxGeometry) for the element 3d outline
  // one mesh (meshLine) for the elastic line (meshLine instead of line because linewidth bug in line)
  // line for the hover effects, since not supported (?) by meshLine
  return (
    <Fragment>
    {/*<line
        onPointerOver={hoveron}
        onPointerOut={(e) => setHover(false)}
        onClick={click}
        visible={false}
        >
          <bufferGeometry ref={ref} />
    </line>*/}
    <Line2
      points={props.coord} 
      linewidth={12}
      onPointerOver={hoverOver}
      onPointerOut={hoverOut}
      onClick={click}
      visible={false}
      />
    <Line2
      points={props.coord} 
      color={hovered ? "red" : (props.active ? "red" : "blue")} 
      linewidth={1}
      />
    {/*<mesh>
        <meshLine attach="geometry" points={props.coord} />
        <meshLineMaterial
          attach="material"
          lineWidth={1.5}
          depthTest={false}
          color={hovered ? "red" : (props.active ? "red" : "blue")}
        />
    </mesh>*/}
    { elementBox }
    { stressArrows }
    </Fragment>
  )
}

const linspace = (start,end,num) => {

  let out = zeros(num);
  for (let i=0;i<num;i++){

    out[i] = start + (end-start)/(num-1)*i;

  }

  return out;

}

const makeMesh = (xv,yv,zv,mesh) => {

  // let mesh_typed = zeros(count(xv)*count(yv)*count(zv)*3);
  // let mesh_typed = new Float32Array(count(xv)*count(yv)*count(zv)*3);
  // let mesh_2d = zeros([count(xv)*count(yv)*count(zv),3]);

  //starting offset in mesh
  let i = count(mesh.x);
  for (let xi=0; xi<count(xv); xi++){
    for (let yi=0; yi<count(yv); yi++){
      for (let zi=0; zi<count(zv); zi++){
      
        // mesh_typed[i*3] = xv[xi];
        // mesh_typed[i*3+1] = yv[yi];
        // mesh_typed[i*3+2] = zv[zi];
        // mesh_2d[i] = [xv[xi],yv[yi],zv[zi]];        

        mesh.x[i] = xv[xi];
        mesh.y[i] = yv[yi];
        mesh.z[i] = zv[zi];

        i = i+1;

      }
    }
  }  
  // return {typed: mesh_typed, twod: mesh_2d};
  return mesh;
}

const makeTriangles = (dim1,dim2,flip,triangles,offset) => {

  // const ntriangles = (dim1-1)*(dim2-1)*2;
  // let triangles = zeros(ntriangles*3);
  // let triangles = new Uint16Array(ntriangles*3);
  
  let k = count(triangles);
  
  for (let i=1; i<dim1; i++){
    for (let j=1; j<dim2; j++){
      if (flip){
        triangles[k] = (j-1)*dim1+i -1 +offset;
        triangles[k+1] = j*dim1+i -1 +offset;
        triangles[k+2] = (j-1)*dim1+i +offset;

        triangles[k+3] = (j-1)*dim1+i +offset;
        triangles[k+4] = j*dim1+i -1 +offset;
        triangles[k+5] = j*dim1+i +offset;
      }
      else{
        triangles[k] = (j-1)*dim1+i -1 +offset;
        triangles[k+1] = (j-1)*dim1+i +offset;
        triangles[k+2] = j*dim1+i -1 +offset;

        triangles[k+3] = j*dim1+i -1 +offset;
        triangles[k+4] = (j-1)*dim1+i +offset;
        triangles[k+5] = j*dim1+i +offset;
      }
      k=k+6;
    }
  }
  return triangles;
}

const makeNormals = (vec,n,normals) => {

  let offset = count(normals);
  for (let i=0;i<n;i++){
    normals[offset + 3*i] = vec[0];
    normals[offset + 3*i+1] = vec[1];
    normals[offset + 3*i+2] = vec[2];
  }
  return normals;
}